import { useQuery, useMutation } from '@tanstack/react-query';
import { publicFetch } from '@/lib/public-fetch';
export function useInvitation(token) {
    return useQuery({
        queryKey: ['onboarding', 'invitation', token],
        enabled: !!token,
        queryFn: () => {
            if (!token)
                throw new Error('token required');
            return publicFetch(`/students/invitations/by-token/${encodeURIComponent(token)}`);
        },
        retry: false,
        gcTime: 0,
    });
}
export function useAcceptInvitation(token) {
    return useMutation({
        mutationFn: (dto) => publicFetch(`/students/invitations/by-token/${encodeURIComponent(token)}/accept`, {
            method: 'POST',
            body: JSON.stringify(dto),
        }),
    });
}
//# sourceMappingURL=useInvitation.js.map